// How long to wait for /cart/add before showing an error instead of an endless spinner
const ADD_TO_CART_TIMEOUT_MS = 12000;

// Waits for the DOM (and so every deferred/module script the add-to-cart flow uses),
// not window "load" – that also waits on images and third-party scripts, which on slow
// mobiles left the button spinning with the request never sent.
function whenPageReady() {
  return new Promise((resolve) => {
    if (document.readyState !== "loading") {
      resolve();
    } else {
      document.addEventListener("DOMContentLoaded", resolve, {once: true});
    }
  });
}

// The read before each add delays the add itself, so it gives up quickly; without it the
// add still goes ahead, just without duplicate protection
const CART_BASELINE_TIMEOUT_MS = 2000;
// Reading the cart is a quick check, so give up sooner than a full add
const CART_CHECK_TIMEOUT_MS = 3000;
// After a request whose reply was lost, Shopify may still be applying it: re-read the
// cart after these pauses, all within the window, before treating an item as not added
const CART_RECHECK_DELAYS_MS = [0, 1500, 2500];
const CART_RECHECK_WINDOW_MS = 6000;

// Resolves with { ok, data }; rejects with an AbortError if no reply arrives in time
async function fetchJsonWithTimeout(url, options = {}, ms = ADD_TO_CART_TIMEOUT_MS) {
  const controller = typeof AbortController === "function" ? new AbortController() : null;
  const timer = controller ? setTimeout(() => controller.abort(), ms) : null;
  try {
    const response = await fetch(url, controller ? {...options, signal: controller.signal} : options);
    const data = await response.json();
    return {ok: response.ok, data};
  } finally {
    clearTimeout(timer);
  }
}

// The current cart, or null if it can't be read
async function fetchCart(ms = CART_CHECK_TIMEOUT_MS) {
  try {
    const {ok, data} = await fetchJsonWithTimeout(
      `${window.routes.cart_url}.js`,
      {headers: {Accept: "application/json"}},
      ms
    );
    return ok ? data : null;
  } catch (e) {
    return null;
  }
}

function cartQuantity(cart, variantId) {
  if (!cart) return 0;
  return cart.items
    .filter((item) => item.variant_id === Number(variantId))
    .reduce((total, item) => total + item.quantity, 0);
}

// The requested items that haven't reached the cart, compared with the cart before they
// were requested. Items count as missing if the cart can't be read at all.
async function findMissingCartItems(items, cartBefore) {
  const deadline = Date.now() + CART_RECHECK_WINDOW_MS;
  let missing = items;
  for (const delay of CART_RECHECK_DELAYS_MS) {
    if (delay) await new Promise((resolve) => setTimeout(resolve, delay));
    const remaining = deadline - Date.now();
    if (remaining <= 0) break;
    const cart = await fetchCart(Math.min(CART_CHECK_TIMEOUT_MS, remaining));
    if (!cart) continue;
    missing = items.filter(
      (item) => cartQuantity(cart, item.id) < cartQuantity(cartBefore, item.id) + item.quantity
    );
    if (!missing.length) break;
  }
  return missing;
}

window.addToCartCompleted = false;
window.addToCartPromise = function() {
  return new Promise((resolve, reject) => {
    if (window.addToCartCompleted) {
      resolve();
    }
    else {
      const onAdded = () => {
        document.removeEventListener("cart:main-product-failed", onFailed);
        resolve();
      };
      const onFailed = () => {
        document.removeEventListener("cart:main-product-added", onAdded);
        reject(new Error("Main product could not be added to cart"));
      };
      document.addEventListener("cart:main-product-added", onAdded, {once: true});
      document.addEventListener("cart:main-product-failed", onFailed, {once: true});
    }
  })
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        var nameId = this.form.querySelector("[name=id]");
        if (nameId) {
          nameId.disabled = false;
        }
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

      }
      
      async onSubmitHandler(evt) {
        evt.preventDefault();
        // A repeat tap while the main product is still being added would add it twice
        if (this.submitInFlight) return;
        this.submitInFlight = true;
        this.missingAddons = [];
        this.querySelector(".addon-missing-warning")?.setAttribute("hidden", "");

        // Every step up to the end of the request runs inside this try, so an error at any
        // of them still reaches the finally below and unlocks the button
        try {
          window.addToCartCompleted = false;

          // Moved to click event listener for instant loading effect
          // this.submitButton.setAttribute("aria-disabled", true);
          // this.submitButton.classList.add("loading");
          // this.querySelector(".loading-overlay__spinner").classList.remove(
          //   "hidden"
          // );

          // Open addon popup
          if($('.popup-addon.pop-up:not(.disabled)').length > 0) {
            $(".popup-addon.pop-up").addClass("is-open");
            $('html').addClass("disable-scroll");
          } 

          // Scroll to addon section
          // This stalls the user until add to cart is done
          let addonSectionScrollOffset;
          if (window.innerWidth > 767) {
            addonSectionScrollOffset = `${$('.header_main')?.innerHeight() + $('.header_main .delivery-countdown-wrapper')?.innerHeight() + 20}px`;
          } else {
            addonSectionScrollOffset = `${$('.header_main')?.innerHeight() + $('.header_main .delivery-countdown-wrapper')?.innerHeight() + $('.product-form__wrap').innerHeight() + 75}px`;
          }

          $('.shopify-section:has(.addons-tab-wrapper)')?.css("scrollMarginBlock", addonSectionScrollOffset);
          console.log($('.shopify-section:has(.addons-tab-wrapper)')?.css("scrollMarginBlock"));
        
          $('.shopify-section:has(.addons-tab-wrapper)')[0]?.scrollIntoView({
            behavior: "smooth",
            block: "start"
          })

          var button_sec = $(
            ".addtocart-btn-trigger .button"
          );
          // Changes the addon section's button to Proceed to cart button
          // button_sec.addClass("sec-cart-btn disabled").prop("disabled", true);
          button_sec.addClass("sec-cart-btn").removeClass('disabled').prop("disabled", false);

          // var svgElement = button_sec.querySelector("svg");
          // if (svgElement) {
          //   button_sec.removeChild(svgElement);
          // }
          button_sec.find("span.button__title"
          ).text("Proceed to Cart");
          button_sec.find(".loading-overlay__spinner")?.addClass("hidden");
        
          // if (this.submitButton.getAttribute("aria-disabled") === "true") return;
          // FOR ONLY VDAY PRODUCTS
          // Attach event listener for popupclose before cart:added triggers
          if ($(".product__info-container .addon-select-popup").length > 0 && $(".product__info-container .button--addon-popup").length > 0) {
            $(document).on("addon-popup:closed", function() {
              // $(document).one("cart:added", function() {
                $('.addon-select-popup')?.removeClass('is-open');
                document.querySelector("cart-drawer.drawer").classList.add("active");
                document.querySelector("html").classList.add("disable-scroll");
              // })
            })
          }

          this.handleErrorMessage();

          await whenPageReady();
          console.log("PAGE READY -> SUBMIT HANDLING");

          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          const variantId = Number(formData.get("id"));
          const quantity = Number(formData.get("quantity")) || 1;
          // The cart before this add: if the reply never arrives, the cart shows whether the
          // bouquet was added, rather than inviting a retry that could add it twice
          const cartBefore = await fetchCart(CART_BASELINE_TIMEOUT_MS);
          let response;
          try {
            response = (await fetchJsonWithTimeout(`${routes.cart_add_url}`, config)).data;
          } catch (e) {
            response = await this.recoverLostAdd(e, cartBefore, variantId, quantity);
          }

          if (response.status) {
            this.error = true;
            this.errorReason = `${response.status}: ${response.description || response.message || "unknown"}`;
            this.handleErrorMessage(
              response.description || response.message || window.cartStrings?.error
            );

            const soldOutMessage =
              this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.querySelector("span").classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            return;
          }

          const items = window.pendingAddonItems;
          window.pendingAddonItems = null;
          if (items && items.length) {
            const extras = await this.addExtras(items, cartBefore);
            if (extras.sections) response = {...response, sections: extras.sections};
            this.missingAddons = extras.missing;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest("quick-add-modal");
          if (quickAddModal) {
            document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  this.renderCart(response);
                });
              },
              {once: true}
            );
            quickAddModal.hide(true);
          } else {
            this.renderCart(response);
          }
        } catch (e) {
          console.error(e);
          this.error = true;
          this.errorReason = e?.name === "AbortError" ? "timeout" : `network: ${e?.message || e}`;
          if (e?.unconfirmed) {
            this.errorReason += " (unconfirmed)";
            this.handleErrorMessage(
              "We couldn't confirm whether this was added to your cart. Please check your cart before trying again."
            );
            this.cart?.refreshFromServer?.();
          } else {
            this.handleErrorMessage(
              "We couldn't add this to your cart. Please check your connection and try again."
            );
          }
        } finally {
          this.submitInFlight = false;
          this.submitButton.classList.remove("loading");
          this.querySelector(".loading-overlay__spinner").classList.add(
            "hidden"
          );

          // Don't show the "Added" state if the main product never made it into the cart
          if (this.error) {
            this.onAddToCartFailed();
          } else {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            this.submitButton.removeAttribute("aria-disabled");

            if ($(".product__info-container .addon-select-popup").length > 0 && $(".product__info-container .button--addon-popup").length > 0) {
              $(".product__info-container .button--addon-popup").prop('disabled', false).find('.loading-overlay__spinner').addClass('hidden');
              $('.product__info-container .addon-select-popup').addClass('is-open');
              $('html').addClass("disable-scroll");
            }

            this.afteraddtocart();
            if (this.missingAddons.length) this.showMissingAddons();
          }
        }
      }

      // The add request got no reply (timeout or dropped connection), but Shopify may still
      // have added the bouquet. Treat it as added if the cart shows it; otherwise rethrow,
      // marked unconfirmed when the cart couldn't be checked.
      async recoverLostAdd(error, cartBefore, variantId, quantity) {
        console.error(error);
        if (!cartBefore) {
          error.unconfirmed = true;
          throw error;
        }
        const missing = await findMissingCartItems([{id: variantId, quantity}], cartBefore);
        if (missing.length) throw error;

        this.reportClarityEvent("add_to_cart_recovered", {atc_recovered_reason: error?.name || "network"});
        return {id: variantId, sections: await this.fetchCartSections()};
      }

      renderCart(response) {
        if (response.sections) {
          this.cart.renderContents(response);
        } else {
          this.cart.refreshFromServer?.();
        }
      }

      async fetchCartSections() {
        if (!this.cart) return null;
        try {
          const ids = this.cart.getSectionsToRender().map((section) => section.id).join(",");
          const {ok, data} = await fetchJsonWithTimeout(
            `${window.Shopify.routes.root}?sections=${ids}`,
            {},
            CART_CHECK_TIMEOUT_MS
          );
          return ok ? data : null;
        } catch (e) {
          return null;
        }
      }

      // Adds extras (queued by additional-product.liquid) once the bouquet is in the cart.
      // Returns the refreshed cart sections and any extras the cart shows were not added.
      // A failed extra never undoes the bouquet.
      async addExtras(items, cartBefore) {
        // Values come from form inputs/data attributes as strings
        const requested = items.map((item) => ({
          ...item,
          id: Number(item.id) || item.id,
          quantity: Number(item.quantity) || 1,
          // Sent as text, as the old form-encoded request did (e.g. "Bundle ID")
          ...(item.properties && {
            properties: Object.fromEntries(
              Object.entries(item.properties).map(([key, value]) => [key, String(value)])
            ),
          }),
        }));
        const body = {items: requested};
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        try {
          const {ok, data} = await fetchJsonWithTimeout(`${routes.cart_add_url}.js`, {
            method: "POST",
            headers: {"Content-Type": "application/json", Accept: "application/json"},
            body: JSON.stringify(body),
          });
          if (ok && !data.status) return {sections: data.sections || null, missing: []};
          console.error("Extras could not be added to cart:", data);
        } catch (e) {
          console.error("Extras could not be added to cart:", e);
        }

        // Failed, partly failed or no reply: the cart shows which extras actually arrived
        const missing = await findMissingCartItems(requested, cartBefore);
        return {sections: await this.fetchCartSections(), missing};
      }

      addonName(variantId) {
        const input = this.querySelector(`input[value="${variantId}"]`) ||
          document.querySelector(`.product__info-container input[value="${variantId}"]`);
        const label = input && ((input.id && document.querySelector(`label[for="${input.id}"]`)) || input.closest("label"));
        const option = document.querySelector(`.product__info-container option[value="${variantId}"]`);
        const name =
          label?.querySelector(".title, .ribbon-title")?.textContent ||
          label?.querySelector("img[alt]")?.alt ||
          option?.textContent ||
          label?.textContent;
        // Drop the "+" prefix and any trailing "(+$139)" price
        return name
          ? name.replace(/\s+/g, " ").replace(/^\+\s*/, "").replace(/\s*\(\+?\$[\d.,]+\)\s*$/, "").trim()
          : "an extra";
      }

      // Bouquet is in the cart but some extras aren't: say which, and offer to add only those
      showMissingAddons() {
        let warning = this.querySelector(".addon-missing-warning");
        if (!warning) {
          warning = document.createElement("div");
          warning.className = "addon-missing-warning";
          warning.setAttribute("role", "alert");
          warning.style.cssText =
            "margin: 0 0 1rem; padding: 12px 14px; background: #fff4e5; border: 1px solid #f5c26b; font-size: 14px; line-height: 1.5;";
          const text = document.createElement("p");
          text.className = "addon-missing-warning__text";
          text.style.margin = "0 0 8px";
          const retry = document.createElement("button");
          retry.type = "button";
          retry.className = "addon-missing-warning__retry";
          retry.style.cssText =
            "background: none; border: 0; padding: 0; font: inherit; font-weight: 700; text-decoration: underline; cursor: pointer;";
          retry.addEventListener("click", () => this.retryMissingAddons(retry));
          warning.append(text, retry);
          const buttons = this.querySelector(".product-form__buttons");
          buttons.parentNode.insertBefore(warning, buttons);
        }

        const names = [...new Set(this.missingAddons.map((item) => this.addonName(item.id)))];
        warning.querySelector(".addon-missing-warning__text").textContent =
          `Your flower is in your cart, but we couldn't add: ${names.join(", ")}.`;
        const retry = warning.querySelector(".addon-missing-warning__retry");
        retry.disabled = false;
        retry.textContent = names.length > 1 ? "Add these extras again" : "Add this extra again";
        warning.hidden = false;
        warning.scrollIntoView({behavior: "smooth", block: "center"});

        this.reportClarityEvent("addons_missing", {
          addons_missing: this.missingAddons.map((item) => item.id).join(","),
        });
      }

      // Adds only the extras that are missing, never the bouquet again
      async retryMissingAddons(retry) {
        retry.disabled = true;
        retry.textContent = "Adding…";
        const cartBefore = await fetchCart();
        const extras = await this.addExtras(this.missingAddons, cartBefore);
        this.missingAddons = extras.missing;
        if (this.cart) this.renderCart({id: null, sections: extras.sections});

        if (this.missingAddons.length) {
          this.showMissingAddons();
          return;
        }
        const warning = this.querySelector(".addon-missing-warning");
        if (warning) warning.hidden = true;
        document.dispatchEvent(new CustomEvent("cart:refresh-addons"));
      }

      onAddToCartFailed() {
        // Retrying should queue the add-ons again rather than skip them
        window.pendingAddonItems = null;
        sessionStorage.setItem("vase_added", "");
        sessionStorage.setItem("babysBreath_added", "");

        const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
        if (!soldOutMessage || soldOutMessage.classList.contains("hidden")) {
          this.submitButton.removeAttribute("aria-disabled");
        }
        if (typeof window.resetAddtoCart === "function") window.resetAddtoCart();

        $(".popup-addon.pop-up").removeClass("is-open");
        $("html").removeClass("disable-scroll");

        document.dispatchEvent(new CustomEvent("cart:main-product-failed"));

        this.errorMessageWrapper?.scrollIntoView({behavior: "smooth", block: "center"});

        this.reportAddToCartFailure();
      }

      // Lets recovered adds and missing extras be counted in Clarity (Custom events / tags)
      reportClarityEvent(name, tags = {}) {
        if (typeof window.clarity !== "function") return;
        try {
          Object.entries(tags).forEach(([key, value]) =>
            window.clarity("set", key, String(value).slice(0, 200))
          );
          window.clarity("event", name);
          window.clarity("upgrade", name);
        } catch (e) {
          console.error("Clarity reporting failed", e);
        }
      }

      // Lets failed adds be filtered in Clarity (Filters > Custom events / Custom tags)
      reportAddToCartFailure() {
        if (typeof window.clarity !== "function") return;
        try {
          const variantId = this.form.querySelector("[name=id]")?.value || "";
          const productPath = window.location.pathname.split("/products/")[1] || "";
          window.clarity("set", "atc_error", (this.errorReason || "unknown").slice(0, 200));
          window.clarity("set", "atc_error_product", `${productPath}|${variantId}`.slice(0, 200));
          window.clarity("event", "add_to_cart_failed");
          window.clarity("upgrade", "add_to_cart_failed");
        } catch (e) {
          console.error("Clarity reporting failed", e);
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      afteraddtocart() {
        if($('.popup-addon.pop-up.is-open').length <= 0) {
          document.dispatchEvent(new CustomEvent('cart:refresh-addons'));
        } 

        var button_sec = $(
          ".addtocart-btn-trigger .button"
        );
        button_sec.removeClass("disabled").prop("disabled", false);

        // Flag for Proceed to Cart button to open the minicart
        addToCartCompleted = true;
        document.dispatchEvent(new CustomEvent("cart:main-product-added"));
        
        document.dispatchEvent(new CustomEvent("cart:added"));
        document.querySelector(".product-form__submit").classList.add("added");
        document.querySelector(".product-form__submit span.button__title").innerHTML =
          "Added";

        // FOR ONLY VDAY PRODUCTS
        // if ($(".product__info-container .addon-select-popup").length == 0) {
        //   document.querySelector("cart-drawer.drawer").classList.add("active");
        //   document.querySelector("html").classList.add("disable-scroll");
        // } else {
        //   $('.addon-select-popup .cart-btn')?.prop("disabled", false);
        // }
        // document.querySelector('.top-btn').classList.add('show');
        // document.querySelector('.bottom-btn').classList.add('show');
        var elementPosition = document.querySelector(
          ".addons-tab-wrapper"
        )?.offsetTop;

        var addtocart_wrapper = document.querySelector(".product-form__wrap");
        if (!addtocart_wrapper.classList.contains("mday")) {
          var popup_status = sessionStorage.getItem("collection_popup_status");
          var soldout_popup = JSON.parse(
            sessionStorage.getItem("soldout_popup")
          );
          var soldout_status = soldout_popup?.status;
          console.log({soldout_status});
          if (popup_status != "shown" && soldout_status != "shown") {
            $(".hover_bkgr_fricc").show();
            $(".hover_bkgr_fricc").addClass("active-popup");
            sessionStorage.setItem("collection_popup_status", "shown");
          }
        }

        refreshFsLightbox();
        hide_addon_tab();
        initCountdown();

        setTimeout(function () {
          // window.scrollTo({
          //   top: elementPosition - 100,
          //   behavior: "smooth"
          // });
          document
            .querySelector(".product-form__submit")
            .classList.remove("added");
          document.querySelector(".product-form__submit span.button__title").innerHTML =
            "Proceed to Checkout";

          // Changes the addon section's button to Checkout button
          // button_sec.classList.add("sec-checkout-btn");

          // var svgElement = button_sec.querySelector("svg");
          // document.querySelector(
          //   ".addtocart-btn-trigger .button span"
          // ).innerHTML = "Proceed to Checkout";
          // if (svgElement) {
          //   button_sec.removeChild(svgElement);
          // }

          document
            .querySelector(".product-form__submit")
            .classList.add("sec-checkout-btn");
          document.querySelector(
            ".product-form__submit"
          ).dataset.additionalProductsHandled = "true";

          if ($(".product__info-container .addon-select-popup").length > 0 && $(".product__info-container .button--addon-popup").length > 0) {
            $('.product__info-container .product-form__submit')?.show();
            $('.product__info-container .button--addon-popup')?.hide();
          }
        }, 1500);
      }
    }
  );
}

// Mobile Add To Cart Sticky Header
// document.addEventListener("DOMContentLoaded", function () {
//   function addClassWhenTouchingHeader(selector, className, options = {}) {
//     const header = document.querySelector(options.headerSelector || '.header_main');
//     if (!header) return;

//     const targets = Array.from(document.querySelectorAll(selector));
//     if (!targets.length) return;

//     let ticking = false;
//     let headerHeight = header.getBoundingClientRect().height;

//     const onResize = () => {
//       headerHeight = header.getBoundingClientRect().height;
//       check();
//     };
//     window.addEventListener('resize', throttle(onResize, 150));

//     const mo = new MutationObserver(onResize);
//     mo.observe(header, { childList: true, subtree: true, attributes: true });

//     function check() {
//       headerHeight = header.getBoundingClientRect().height;

//       for (const el of targets) {
//         const rect = el.getBoundingClientRect();
//         const nextEl = el.nextElementSibling;

//         const touchedOrAbove = rect.top <= headerHeight;
//         const completelyAbove = rect.bottom <= headerHeight;

//         if (touchedOrAbove && completelyAbove) {
//           nextEl.classList.add(className);
//           nextEl.style.top = headerHeight + 'px';
//         } else if (!touchedOrAbove) {
//           nextEl.classList.remove(className);
//         }
//       }
//       ticking = false;
//     }

//     function onScroll() {
//       if (!ticking) {
//         ticking = true;
//         requestAnimationFrame(check);
//       }
//     }
//     window.addEventListener('scroll', onScroll, { passive: true });
//     requestAnimationFrame(check);

//     return function destroy() {
//       window.removeEventListener('scroll', onScroll);
//       window.removeEventListener('resize', onResize);
//       mo.disconnect();
//     };
//   }

//   function throttle(fn, wait = 100) {
//     let last = 0;
//     return function (...args) {
//       const now = Date.now();
//       if (now - last >= wait) {
//         last = now;
//         fn.apply(this, args);
//       }
//     };
//   }

//   addClassWhenTouchingHeader('.mobile-sticky-addtocart-btn', 'sticky-addtocart-mobile', {
//     headerSelector: '.header_main'
//   });
// });

// function whenPageReady() {
//   return new Promise((resolve) => {
//     if (document.readyState === "complete") {
//       // When the page is already loaded and user clicks the A2C button
//       resolve();
//     } else {
//       // When the page is not yet loaded and user clicks the A2C button
//       window.addEventListener("load", resolve, {once: true});
//     }
//   });
// }

// async function test() {
//   console.time("Page ready time");
//   await whenPageReady();
//   console.timeEnd("Page ready time");
//   console.log("Page is ready");
// }
// test();

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header_main");
  const trigger = document.querySelector(".product__info-container .product-form__wrap");
  if (!header || !trigger) return;

  const target = trigger.previousElementSibling || document.querySelector(".product__info-container .mobile-sticky-addtocart-btn");
  if (!target) return;

  let ticking = false;
  let isSticky = false;

  function getHeaderHeight() {
    return header.offsetHeight - 1;
  }

  let initialHeaderHeight = getHeaderHeight();
  function updateSticky() {
    const headerHeight = getHeaderHeight();
    const rect = trigger.getBoundingClientRect();

    // Trigger has crossed the top of the viewport
    if (rect.top <= 0) {
      if (!isSticky) {
        isSticky = true;
        target.classList.add("sticky-addtocart-mobile");
        target.style.top = headerHeight + "px";
      } else if (isSticky && initialHeaderHeight != headerHeight) {
        target.style.top = headerHeight + "px";
        initialHeaderHeight = headerHeight;
      }
    } else {
      if (isSticky) {
        isSticky = false;
        target.classList.remove("sticky-addtocart-mobile");
        target.style.top = "";
      }
    }
  }

  if (window.innerWidth <= 1024) {
    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(() => {
          ticking = false;
          updateSticky();
        });
      },
      {passive: true}
    );
  }

  window.addEventListener("resize", updateSticky);

  // Run once on load
  updateSticky();
});